var _rect, _g, _g2, _path, _g3, _g4, _g5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurveys(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 204,
    viewBox: "0 0 375 204",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 204,
    fill: "url(#paint0_linear_102_67405)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_102_67405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.8053 50.6559H77.7395L76.6068 54H71.7793L78.6294 35.0678H83.9693L90.8194 54H85.938L84.8053 50.6559ZM83.6187 47.096L81.2724 40.1649L78.9531 47.096H83.6187ZM109.841 54H105.229L97.5159 42.3224V54H92.9042V35.0678H97.5159L105.229 46.7993V35.0678H109.841V54ZM120.034 54.1888C118.649 54.1888 117.409 53.964 116.312 53.5146C115.215 53.0651 114.334 52.3998 113.669 51.5189C113.022 50.6379 112.68 49.5771 112.644 48.3365H117.553C117.624 49.0377 117.867 49.5771 118.281 49.9547C118.694 50.3142 119.234 50.494 119.899 50.494C120.582 50.494 121.121 50.3412 121.517 50.0356C121.913 49.7119 122.11 49.2714 122.11 48.7141C122.11 48.2466 121.949 47.8601 121.625 47.5544C121.319 47.2488 120.933 46.9971 120.465 46.7993C120.016 46.6015 119.368 46.3768 118.523 46.1251C117.301 45.7475 116.303 45.3699 115.53 44.9924C114.757 44.6148 114.092 44.0574 113.534 43.3203C112.977 42.5831 112.698 41.6213 112.698 40.4346C112.698 38.6727 113.336 37.2972 114.613 36.3084C115.889 35.3015 117.553 34.7981 119.602 34.7981C121.688 34.7981 123.369 35.3015 124.645 36.3084C125.922 37.2972 126.605 38.6816 126.695 40.4616H121.706C121.67 39.8503 121.445 39.3738 121.032 39.0322C120.618 38.6727 120.088 38.4929 119.44 38.4929C118.883 38.4929 118.434 38.6457 118.092 38.9513C117.75 39.239 117.58 39.6615 117.58 40.2189C117.58 40.8302 117.867 41.3066 118.443 41.6482C119.018 41.9898 119.917 42.3584 121.139 42.754C122.362 43.1675 123.351 43.563 124.106 43.9406C124.879 44.3181 125.544 44.8665 126.102 45.5857C126.659 46.3049 126.938 47.2308 126.938 48.3635C126.938 49.4422 126.659 50.4221 126.102 51.3031C125.562 52.1841 124.771 52.8853 123.728 53.4067C122.686 53.9281 121.454 54.1888 120.034 54.1888ZM155.828 35.0678L150.893 54H145.31L142.289 41.5403L139.161 54H133.578L128.778 35.0678H133.713L136.437 48.8489L139.808 35.0678H144.878L148.115 48.8489L150.866 35.0678H155.828ZM162.752 38.7625V42.5921H168.928V46.152H162.752V50.3053H169.737V54H158.141V35.0678H169.737V38.7625H162.752ZM182.386 54L178.449 46.8532H177.343V54H172.731V35.0678H180.471C181.964 35.0678 183.231 35.3285 184.274 35.8499C185.335 36.3713 186.126 37.0905 186.647 38.0074C187.169 38.9064 187.429 39.9132 187.429 41.0279C187.429 42.2865 187.07 43.4102 186.351 44.3991C185.649 45.3879 184.607 46.0891 183.222 46.5026L187.591 54H182.386ZM177.343 43.59H180.202C181.047 43.59 181.676 43.3832 182.089 42.9697C182.521 42.5562 182.737 41.9719 182.737 41.2167C182.737 40.4976 182.521 39.9312 182.089 39.5177C181.676 39.1042 181.047 38.8974 180.202 38.8974H177.343V43.59Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_102_67405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.696 106.336C82.632 106.336 79.272 105.392 76.616 103.504C73.992 101.584 72.568 98.784 72.344 95.104H83.672C83.832 97.056 84.696 98.032 86.264 98.032C86.84 98.032 87.32 97.904 87.704 97.648C88.12 97.36 88.328 96.928 88.328 96.352C88.328 95.552 87.896 94.912 87.032 94.432C86.168 93.92 84.824 93.344 83 92.704C80.824 91.936 79.016 91.184 77.576 90.448C76.168 89.712 74.952 88.64 73.928 87.232C72.904 85.824 72.408 84.016 72.44 81.808C72.44 79.6 73 77.728 74.12 76.192C75.272 74.624 76.824 73.44 78.776 72.64C80.76 71.84 82.984 71.44 85.448 71.44C89.608 71.44 92.904 72.4 95.336 74.32C97.8 76.24 99.096 78.944 99.224 82.432H87.752C87.72 81.472 87.48 80.784 87.032 80.368C86.584 79.952 86.04 79.744 85.4 79.744C84.952 79.744 84.584 79.904 84.296 80.224C84.008 80.512 83.864 80.928 83.864 81.472C83.864 82.24 84.28 82.88 85.112 83.392C85.976 83.872 87.336 84.464 89.192 85.168C91.336 85.968 93.096 86.736 94.472 87.472C95.88 88.208 97.096 89.232 98.12 90.544C99.144 91.856 99.656 93.504 99.656 95.488C99.656 97.568 99.144 99.44 98.12 101.104C97.096 102.736 95.608 104.016 93.656 104.944C91.704 105.872 89.384 106.336 86.696 106.336ZM113.816 72.016V91.168C113.816 92.736 114.152 93.984 114.824 94.912C115.528 95.808 116.648 96.256 118.184 96.256C119.72 96.256 120.856 95.808 121.592 94.912C122.328 93.984 122.696 92.736 122.696 91.168V72.016H133.304V91.168C133.304 94.4 132.632 97.168 131.288 99.472C129.944 101.744 128.104 103.456 125.768 104.608C123.432 105.76 120.824 106.336 117.944 106.336C115.064 106.336 112.504 105.76 110.264 104.608C108.056 103.456 106.328 101.744 105.08 99.472C103.832 97.2 103.208 94.432 103.208 91.168V72.016H113.816ZM154.988 106L148.604 93.808H148.556V106H137.9V72.016H153.74C156.492 72.016 158.844 72.512 160.796 73.504C162.748 74.464 164.204 75.792 165.164 77.488C166.156 79.152 166.652 81.04 166.652 83.152C166.652 85.424 166.012 87.44 164.732 89.2C163.484 90.96 161.676 92.224 159.308 92.992L166.7 106H154.988ZM148.556 86.704H152.78C153.804 86.704 154.572 86.48 155.084 86.032C155.596 85.552 155.852 84.816 155.852 83.824C155.852 82.928 155.58 82.224 155.036 81.712C154.524 81.2 153.772 80.944 152.78 80.944H148.556V86.704ZM204.28 72.016L192.856 106H179.08L167.656 72.016H178.984L185.992 95.392L192.952 72.016H204.28ZM217.322 80.512V84.688H227.882V92.704H217.322V97.504H229.322V106H206.666V72.016H229.322V80.512H217.322ZM265.978 72.016L253.786 95.68V106H243.13V95.68L230.938 72.016H243.13L248.554 84.064L253.978 72.016H265.978ZM281.696 106.336C277.632 106.336 274.272 105.392 271.616 103.504C268.992 101.584 267.568 98.784 267.344 95.104H278.672C278.832 97.056 279.696 98.032 281.264 98.032C281.84 98.032 282.32 97.904 282.704 97.648C283.12 97.36 283.328 96.928 283.328 96.352C283.328 95.552 282.896 94.912 282.032 94.432C281.168 93.92 279.824 93.344 278 92.704C275.824 91.936 274.016 91.184 272.576 90.448C271.168 89.712 269.952 88.64 268.928 87.232C267.904 85.824 267.408 84.016 267.44 81.808C267.44 79.6 268 77.728 269.12 76.192C270.272 74.624 271.824 73.44 273.776 72.64C275.76 71.84 277.984 71.44 280.448 71.44C284.608 71.44 287.904 72.4 290.336 74.32C292.8 76.24 294.096 78.944 294.224 82.432H282.752C282.72 81.472 282.48 80.784 282.032 80.368C281.584 79.952 281.04 79.744 280.4 79.744C279.952 79.744 279.584 79.904 279.296 80.224C279.008 80.512 278.864 80.928 278.864 81.472C278.864 82.24 279.28 82.88 280.112 83.392C280.976 83.872 282.336 84.464 284.192 85.168C286.336 85.968 288.096 86.736 289.472 87.472C290.88 88.208 292.096 89.232 293.12 90.544C294.144 91.856 294.656 93.504 294.656 95.488C294.656 97.568 294.144 99.44 293.12 101.104C292.096 102.736 290.608 104.016 288.656 104.944C286.704 105.872 284.384 106.336 281.696 106.336Z",
    fill: "url(#paint1_linear_102_67405)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.696 101.336C82.632 101.336 79.272 100.392 76.616 98.504C73.992 96.584 72.568 93.784 72.344 90.104H83.672C83.832 92.056 84.696 93.032 86.264 93.032C86.84 93.032 87.32 92.904 87.704 92.648C88.12 92.36 88.328 91.928 88.328 91.352C88.328 90.552 87.896 89.912 87.032 89.432C86.168 88.92 84.824 88.344 83 87.704C80.824 86.936 79.016 86.184 77.576 85.448C76.168 84.712 74.952 83.64 73.928 82.232C72.904 80.824 72.408 79.016 72.44 76.808C72.44 74.6 73 72.728 74.12 71.192C75.272 69.624 76.824 68.44 78.776 67.64C80.76 66.84 82.984 66.44 85.448 66.44C89.608 66.44 92.904 67.4 95.336 69.32C97.8 71.24 99.096 73.944 99.224 77.432H87.752C87.72 76.472 87.48 75.784 87.032 75.368C86.584 74.952 86.04 74.744 85.4 74.744C84.952 74.744 84.584 74.904 84.296 75.224C84.008 75.512 83.864 75.928 83.864 76.472C83.864 77.24 84.28 77.88 85.112 78.392C85.976 78.872 87.336 79.464 89.192 80.168C91.336 80.968 93.096 81.736 94.472 82.472C95.88 83.208 97.096 84.232 98.12 85.544C99.144 86.856 99.656 88.504 99.656 90.488C99.656 92.568 99.144 94.44 98.12 96.104C97.096 97.736 95.608 99.016 93.656 99.944C91.704 100.872 89.384 101.336 86.696 101.336ZM113.816 67.016V86.168C113.816 87.736 114.152 88.984 114.824 89.912C115.528 90.808 116.648 91.256 118.184 91.256C119.72 91.256 120.856 90.808 121.592 89.912C122.328 88.984 122.696 87.736 122.696 86.168V67.016H133.304V86.168C133.304 89.4 132.632 92.168 131.288 94.472C129.944 96.744 128.104 98.456 125.768 99.608C123.432 100.76 120.824 101.336 117.944 101.336C115.064 101.336 112.504 100.76 110.264 99.608C108.056 98.456 106.328 96.744 105.08 94.472C103.832 92.2 103.208 89.432 103.208 86.168V67.016H113.816ZM154.988 101L148.604 88.808H148.556V101H137.9V67.016H153.74C156.492 67.016 158.844 67.512 160.796 68.504C162.748 69.464 164.204 70.792 165.164 72.488C166.156 74.152 166.652 76.04 166.652 78.152C166.652 80.424 166.012 82.44 164.732 84.2C163.484 85.96 161.676 87.224 159.308 87.992L166.7 101H154.988ZM148.556 81.704H152.78C153.804 81.704 154.572 81.48 155.084 81.032C155.596 80.552 155.852 79.816 155.852 78.824C155.852 77.928 155.58 77.224 155.036 76.712C154.524 76.2 153.772 75.944 152.78 75.944H148.556V81.704ZM204.28 67.016L192.856 101H179.08L167.656 67.016H178.984L185.992 90.392L192.952 67.016H204.28ZM217.322 75.512V79.688H227.882V87.704H217.322V92.504H229.322V101H206.666V67.016H229.322V75.512H217.322ZM265.978 67.016L253.786 90.68V101H243.13V90.68L230.938 67.016H243.13L248.554 79.064L253.978 67.016H265.978ZM281.696 101.336C277.632 101.336 274.272 100.392 271.616 98.504C268.992 96.584 267.568 93.784 267.344 90.104H278.672C278.832 92.056 279.696 93.032 281.264 93.032C281.84 93.032 282.32 92.904 282.704 92.648C283.12 92.36 283.328 91.928 283.328 91.352C283.328 90.552 282.896 89.912 282.032 89.432C281.168 88.92 279.824 88.344 278 87.704C275.824 86.936 274.016 86.184 272.576 85.448C271.168 84.712 269.952 83.64 268.928 82.232C267.904 80.824 267.408 79.016 267.44 76.808C267.44 74.6 268 72.728 269.12 71.192C270.272 69.624 271.824 68.44 273.776 67.64C275.76 66.84 277.984 66.44 280.448 66.44C284.608 66.44 287.904 67.4 290.336 69.32C292.8 71.24 294.096 73.944 294.224 77.432H282.752C282.72 76.472 282.48 75.784 282.032 75.368C281.584 74.952 281.04 74.744 280.4 74.744C279.952 74.744 279.584 74.904 279.296 75.224C279.008 75.512 278.864 75.928 278.864 76.472C278.864 77.24 279.28 77.88 280.112 78.392C280.976 78.872 282.336 79.464 284.192 80.168C286.336 80.968 288.096 81.736 289.472 82.472C290.88 83.208 292.096 84.232 293.12 85.544C294.144 86.856 294.656 88.504 294.656 90.488C294.656 92.568 294.144 94.44 293.12 96.104C292.096 97.736 290.608 99.016 288.656 99.944C286.704 100.872 284.384 101.336 281.696 101.336Z",
    fill: "url(#paint2_linear_102_67405)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_102_67405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.581 140.899H105.839L104.814 144H99.2583L106.189 124.987H112.284L119.188 144H113.606L112.581 140.899ZM111.259 136.853L109.21 130.704L107.187 136.853H111.259ZM138.522 144H133.236L126.197 133.374V144H120.911V124.987H126.197L133.236 135.748V124.987H138.522V144ZM149.057 124.987C151.053 124.987 152.797 125.391 154.289 126.2C155.8 126.992 156.959 128.106 157.768 129.545C158.577 130.983 158.982 132.628 158.982 134.48C158.982 136.314 158.568 137.95 157.741 139.388C156.932 140.827 155.773 141.959 154.262 142.786C152.77 143.595 151.035 144 149.057 144H141.533V124.987H149.057ZM148.653 139.334C150.199 139.334 151.413 138.912 152.294 138.067C153.175 137.222 153.615 136.026 153.615 134.48C153.615 132.916 153.175 131.711 152.294 130.866C151.413 130.003 150.199 129.572 148.653 129.572H146.819V139.334H148.653ZM193.307 124.987L188.641 144H182.142L179.526 132.349L176.856 144H170.356L165.745 124.987H171.462L173.673 137.986L176.667 124.987H182.465L185.378 137.878L187.589 124.987H193.307ZM200.836 124.987V144H195.55V124.987H200.836ZM221.457 144H216.171L209.132 133.374V144H203.846V124.987H209.132L216.171 135.748V124.987H221.457V144Z",
    fill: "url(#paint3_linear_102_67405)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_102_67405)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_ii_102_67405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.192 123.332L236.986 126.207C236.829 126.347 236.791 126.574 236.879 126.767C237.116 127.289 236.997 127.939 236.552 128.339C236.106 128.738 235.466 128.781 234.984 128.466C234.9 128.409 234.8 128.382 234.7 128.388C234.599 128.395 234.503 128.435 234.427 128.502L225.374 136.62C224.615 137.3 224.538 138.478 225.202 139.252L230.841 145.816C231.505 146.59 232.658 146.665 233.417 145.984L242.47 137.867C242.626 137.726 242.665 137.499 242.577 137.306C242.339 136.784 242.459 136.134 242.904 135.735C243.349 135.335 243.99 135.292 244.472 135.607C244.647 135.722 244.872 135.712 245.029 135.571L248.235 132.697C248.994 132.016 249.071 130.838 248.407 130.065L242.768 123.5C242.104 122.726 240.951 122.651 240.192 123.332ZM241.949 134.622C241.403 135.112 240.568 135.057 240.09 134.501C239.612 133.945 239.668 133.092 240.214 132.602C240.76 132.113 241.595 132.167 242.072 132.723C242.55 133.28 242.494 134.133 241.949 134.622ZM239.248 131.477C238.702 131.967 237.866 131.912 237.389 131.356C236.911 130.8 236.967 129.947 237.513 129.457C238.058 128.968 238.894 129.022 239.371 129.578C239.849 130.135 239.793 130.988 239.248 131.477Z",
    fill: "url(#paint4_linear_102_67405)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M240.192 123.332L236.986 126.207C236.829 126.347 236.791 126.574 236.879 126.767C237.116 127.289 236.997 127.939 236.552 128.339C236.106 128.738 235.466 128.781 234.984 128.466C234.9 128.409 234.8 128.382 234.7 128.388C234.599 128.395 234.503 128.435 234.426 128.502L225.374 136.62C224.615 137.3 224.538 138.478 225.202 139.252L230.841 145.817C231.505 146.59 232.658 146.665 233.417 145.985L242.47 137.867C242.627 137.726 242.665 137.499 242.577 137.307C242.339 136.784 242.459 136.134 242.904 135.735C243.349 135.335 243.99 135.293 244.472 135.608C244.647 135.722 244.872 135.712 245.029 135.572L248.235 132.697C248.994 132.016 249.071 130.838 248.407 130.065L242.768 123.5C242.104 122.726 240.951 122.651 240.192 123.332ZM241.949 134.623C241.403 135.112 240.568 135.057 240.09 134.501C239.612 133.945 239.668 133.092 240.214 132.603C240.76 132.113 241.595 132.168 242.072 132.724C242.55 133.28 242.494 134.133 241.949 134.623ZM239.247 131.477C238.702 131.967 237.866 131.912 237.389 131.356C236.911 130.8 236.967 129.947 237.513 129.457C238.058 128.968 238.894 129.022 239.371 129.579C239.849 130.135 239.793 130.988 239.247 131.477Z",
    fill: "url(#paint5_linear_102_67405)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.751 136.208L231.83 141.517C231.784 141.558 231.73 141.59 231.672 141.61C231.614 141.631 231.553 141.639 231.492 141.635C231.431 141.631 231.371 141.615 231.316 141.587C231.261 141.559 231.212 141.521 231.172 141.474C231.131 141.427 231.1 141.372 231.081 141.313C231.061 141.254 231.053 141.191 231.057 141.129C231.061 141.066 231.077 141.005 231.104 140.949C231.132 140.893 231.169 140.843 231.215 140.801L237.13 135.498C237.324 135.324 237.618 135.343 237.788 135.541C237.829 135.587 237.861 135.641 237.881 135.699C237.901 135.758 237.91 135.82 237.907 135.882C237.903 135.944 237.887 136.005 237.861 136.061C237.834 136.117 237.797 136.167 237.751 136.208ZM238.964 137.62L233.043 142.929C232.95 143.013 232.828 143.055 232.705 143.047C232.581 143.039 232.466 142.981 232.385 142.886C232.303 142.791 232.262 142.667 232.27 142.541C232.278 142.415 232.335 142.297 232.428 142.214L238.343 136.91C238.537 136.736 238.831 136.755 239.001 136.953C239.172 137.139 239.152 137.452 238.964 137.62Z",
    fill: "#D88B4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.995 136.08L229.443 138.369C229.373 138.432 229.291 138.48 229.203 138.511C229.115 138.541 229.022 138.554 228.929 138.548C228.836 138.542 228.745 138.517 228.662 138.475C228.579 138.433 228.504 138.375 228.443 138.304C228.382 138.232 228.335 138.149 228.305 138.059C228.275 137.97 228.263 137.874 228.269 137.78C228.275 137.685 228.3 137.592 228.341 137.507C228.382 137.421 228.439 137.345 228.509 137.282L231.062 134.993C231.357 134.729 231.804 134.758 232.062 135.058C232.325 135.365 232.29 135.815 231.995 136.08ZM244.344 128.649L242.952 129.898C242.726 130.1 242.703 130.449 242.901 130.679L244.12 132.098C244.317 132.328 244.658 132.35 244.884 132.148L246.277 130.899C246.502 130.697 246.525 130.348 246.327 130.118L245.109 128.699C244.911 128.469 244.57 128.447 244.344 128.649Z",
    fill: "#D6894C"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_102_67405)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_ii_102_67405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.451 131.25L247.267 132.228C247.062 132.275 246.922 132.455 246.911 132.665C246.88 133.233 246.472 133.743 245.89 133.879C245.309 134.015 244.72 133.746 244.438 133.242C244.389 133.153 244.313 133.081 244.221 133.039C244.128 132.997 244.025 132.986 243.925 133.008L232.108 135.768C231.117 135.999 230.502 136.989 230.733 137.98L232.697 146.39C232.929 147.381 233.919 147.996 234.91 147.765L246.727 145.005C246.932 144.958 247.071 144.778 247.083 144.568C247.114 144 247.522 143.49 248.103 143.354C248.685 143.218 249.274 143.487 249.556 143.991C249.659 144.174 249.863 144.273 250.068 144.225L254.253 143.248C255.244 143.016 255.859 142.026 255.628 141.036L253.664 132.625C253.432 131.634 252.442 131.019 251.451 131.25ZM247.77 141.929C247.058 142.096 246.341 141.65 246.174 140.937C246.008 140.225 246.453 139.508 247.166 139.341C247.878 139.175 248.596 139.621 248.762 140.333C248.928 141.046 248.483 141.763 247.77 141.929ZM246.829 137.9C246.117 138.066 245.4 137.621 245.233 136.908C245.067 136.196 245.513 135.478 246.225 135.312C246.938 135.146 247.655 135.591 247.821 136.304C247.988 137.016 247.542 137.734 246.829 137.9Z",
    fill: "url(#paint6_linear_102_67405)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M251.451 131.25L247.267 132.228C247.062 132.275 246.922 132.455 246.911 132.665C246.88 133.233 246.472 133.743 245.89 133.879C245.309 134.015 244.72 133.746 244.438 133.242C244.389 133.153 244.313 133.081 244.221 133.039C244.128 132.997 244.025 132.986 243.925 133.008L232.108 135.768C231.117 135.999 230.502 136.989 230.733 137.98L232.697 146.39C232.929 147.381 233.919 147.996 234.91 147.765L246.727 145.005C246.932 144.958 247.071 144.778 247.083 144.568C247.114 144 247.522 143.49 248.103 143.354C248.685 143.218 249.274 143.487 249.556 143.991C249.659 144.174 249.863 144.273 250.068 144.225L254.253 143.248C255.244 143.016 255.859 142.026 255.628 141.036L253.664 132.625C253.432 131.634 252.442 131.019 251.451 131.25ZM247.77 141.929C247.058 142.096 246.341 141.65 246.174 140.937C246.008 140.225 246.453 139.508 247.166 139.341C247.878 139.175 248.596 139.621 248.762 140.333C248.928 141.046 248.483 141.763 247.77 141.929ZM246.829 137.9C246.117 138.066 245.4 137.621 245.233 136.908C245.067 136.196 245.513 135.478 246.225 135.312C246.938 135.146 247.655 135.591 247.821 136.304C247.988 137.016 247.542 137.734 246.829 137.9Z",
    fill: "url(#paint7_linear_102_67405)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.298 141.307L235.567 143.112C235.507 143.126 235.445 143.128 235.384 143.118C235.323 143.108 235.264 143.086 235.212 143.053C235.159 143.021 235.114 142.978 235.078 142.928C235.041 142.878 235.016 142.821 235.002 142.76C234.988 142.7 234.985 142.638 234.996 142.577C235.006 142.516 235.028 142.457 235.06 142.405C235.093 142.352 235.136 142.307 235.186 142.271C235.236 142.235 235.293 142.209 235.353 142.195L243.076 140.391C243.33 140.332 243.582 140.489 243.641 140.743C243.657 140.802 243.66 140.864 243.65 140.925C243.641 140.986 243.62 141.044 243.588 141.097C243.556 141.149 243.514 141.195 243.464 141.231C243.414 141.267 243.358 141.293 243.298 141.307ZM243.721 143.116L235.99 144.922C235.868 144.95 235.74 144.929 235.634 144.863C235.528 144.797 235.453 144.692 235.424 144.57C235.396 144.449 235.417 144.321 235.483 144.215C235.549 144.109 235.654 144.033 235.776 144.005L243.498 142.201C243.752 142.142 244.005 142.299 244.064 142.553C244.13 142.796 243.966 143.059 243.721 143.116Z",
    fill: "#D88B4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.245 138.454L234.912 139.232C234.82 139.253 234.725 139.256 234.633 139.241C234.54 139.226 234.451 139.193 234.372 139.143C234.292 139.093 234.223 139.029 234.168 138.952C234.113 138.876 234.074 138.79 234.053 138.698C234.032 138.607 234.028 138.512 234.044 138.42C234.059 138.327 234.092 138.238 234.142 138.159C234.191 138.079 234.256 138.01 234.332 137.955C234.409 137.9 234.495 137.861 234.586 137.84L237.92 137.061C238.304 136.972 238.688 137.21 238.778 137.595C238.87 137.988 238.63 138.364 238.245 138.454ZM252.676 137.864L250.858 138.289C250.563 138.358 250.381 138.651 250.45 138.946L250.875 140.764C250.943 141.058 251.236 141.24 251.531 141.172L253.349 140.747C253.644 140.678 253.826 140.385 253.757 140.09L253.333 138.272C253.264 137.978 252.971 137.796 252.676 137.864Z",
    fill: "#D6894C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_102_67405",
    x: 67.7793,
    y: 34.7981,
    width: 123.812,
    height: 27.3907,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.197063 0 0 0 0 0.639338 0 0 0 0 0.875833 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_102_67405"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_102_67405",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_102_67405",
    x: 68.344,
    y: 71.44,
    width: 230.312,
    height: 42.896,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_102_67405"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_102_67405",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_102_67405",
    x: 95.2583,
    y: 124.987,
    width: 130.198,
    height: 27.0131,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.34902 0 0 0 0 0.658824 0 0 0 0 0.996078 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_102_67405"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_102_67405",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_102_67405",
    x: 220.75,
    y: 122.867,
    width: 32.1084,
    height: 31.5829,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.905882 0 0 0 0 0.647059 0 0 0 0 0.0627451 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_102_67405"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_102_67405",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_ii_102_67405",
    x: 224.75,
    y: 122.601,
    width: 24.1084,
    height: 24.1141,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.265625
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.442708
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.866667 0 0 0 0 0.745098 0 0 0 0 0.270588 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_102_67405"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.265625
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.442708
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.815686 0 0 0 0 0.588235 0 0 0 0 0.286275 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_102_67405",
    result: "effect2_innerShadow_102_67405"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_102_67405",
    x: 226.685,
    y: 131.202,
    width: 32.9917,
    height: 24.6121,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.905882 0 0 0 0 0.647059 0 0 0 0 0.0627451 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_102_67405"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_102_67405",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_ii_102_67405",
    x: 230.685,
    y: 130.936,
    width: 24.9917,
    height: 17.1433,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.265625
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.442708
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.866667 0 0 0 0 0.745098 0 0 0 0 0.270588 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_102_67405"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.265625
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.442708
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.815686 0 0 0 0 0.588235 0 0 0 0 0.286275 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_102_67405",
    result: "effect2_innerShadow_102_67405"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_102_67405",
    x1: 188.003,
    y1: -256.8,
    x2: 188.003,
    y2: 182.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EA9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594621,
    stopColor: "#1DAAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_102_67405",
    x1: 89,
    y1: 105,
    x2: 284.5,
    y2: 75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99BDD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526411,
    stopColor: "#559BC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7CDD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_102_67405",
    x1: 89,
    y1: 100,
    x2: 284.5,
    y2: 70,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526411,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5FCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_102_67405",
    x1: 214,
    y1: 122.5,
    x2: 161,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54A0FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3940BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_102_67405",
    x1: 246.573,
    y1: 129.451,
    x2: 231.356,
    y2: 142.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE74D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3C240"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_102_67405",
    x1: 246.05,
    y1: 126.985,
    x2: 244.304,
    y2: 128.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF250",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_102_67405",
    x1: 254.283,
    y1: 139.627,
    x2: 234.782,
    y2: 144.181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE74D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3C240"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_102_67405",
    x1: 254.963,
    y1: 137.228,
    x2: 252.725,
    y2: 137.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF250",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveys);
export default __webpack_public_path__ + "static/media/Surveys.d523c369019d1d95c4ed01e652c40b64.svg";
export { ForwardRef as ReactComponent };